import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Typography, Link, Divider } from "@mui/material";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        mt: "auto",
        borderTop: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 3,
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <Link
              component={RouterLink}
              to="/"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              Home
            </Link>
            <Link
              component={RouterLink}
              to="/about"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              About
            </Link>
            <Link
              component={RouterLink}
              to="/contact"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              Contact
            </Link>
            <Link
              component={RouterLink}
              to="/developer-formatter-toolkit"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              Formatter Toolkit
            </Link>
            <Link
              component={RouterLink}
              to="/image-compression-tool"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              Image Compression Tool
            </Link>
            <Link
              component={RouterLink}
              to="/word-counter"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              Word Counter
            </Link>
            <Link
              component={RouterLink}
              to="/password-generator"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              Password Generator
            </Link>
            <Link
              component={RouterLink}
              to="/qr-generator"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              QR Generator
            </Link>
            <Link
              component={RouterLink}
              to="/unit-converter"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              Unit Converter
            </Link>
            <Link
              component={RouterLink}
              to="/support"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              Support
            </Link>
            <Link
              component={RouterLink}
              to="/privacy-policy"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              to="/terms-and-conditions"
              sx={{
                color: "text.secondary",
                textDecoration: "none",
                "&:hover": { color: "primary.main" },
              }}
            >
              Terms & Conditions
            </Link>
          </Box>

          <Divider sx={{ width: "100%", maxWidth: 600 }} />

          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            © {currentYear} Shashi Sharma. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
